import React from 'react';

const ArrowLeftIcon = () => (
  <svg
    width='20'
    height='16'
    viewBox='0 0 20 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.3749 7.99998C19.3749 8.29835 19.2564 8.58449 19.0454 8.79547C18.8344 9.00645 18.5483 9.12498 18.2499 9.12498H4.46866L9.29866 13.954C9.51 14.1654 9.62874 14.452 9.62874 14.7509C9.62874 15.0498 9.51 15.3364 9.29866 15.5478C9.08732 15.7591 8.80067 15.8779 8.50179 15.8779C8.2029 15.8779 7.91625 15.7591 7.70491 15.5478L0.954911 8.79779C0.850031 8.69327 0.766814 8.56908 0.710033 8.43233C0.653252 8.29559 0.624023 8.14898 0.624023 8.00091C0.624023 7.85285 0.653252 7.70624 0.710033 7.56949C0.766814 7.43275 0.850031 7.30856 0.954911 7.20404L7.70491 0.454039C7.80956 0.349392 7.93379 0.266381 8.07052 0.209746C8.20725 0.153112 8.35379 0.123962 8.50179 0.123962C8.64978 0.123962 8.79632 0.153112 8.93305 0.209746C9.06978 0.266381 9.19401 0.349392 9.29866 0.454039C9.40331 0.558686 9.48632 0.68292 9.54295 0.819648C9.59959 0.956376 9.62874 1.10292 9.62874 1.25091C9.62874 1.39891 9.59959 1.54545 9.54295 1.68218C9.48632 1.81891 9.40331 1.94314 9.29866 2.04779L4.46866 6.87498H18.2499C18.5483 6.87498 18.8344 6.9935 19.0454 7.20448C19.2564 7.41546 19.3749 7.70161 19.3749 7.99998Z'
      fill='#53555F'
    />
  </svg>
);

export default ArrowLeftIcon;
